import { type AllianceStatus, AllianceStatusValues } from '@inpart-io/padme-iap';

import { ALLIANCE_PREFIX } from '@/constants/router-prefixes.constants';
import { ICONS_NAME } from '@/constants/ui/icons.constants';

export interface AllianceStatusOption {
    key: AllianceStatus;
    label: string;
    value: AllianceStatus;
}

export const AllianceStatusIcon: Record<AllianceStatus, string> = {
    [AllianceStatusValues.DRAFT]: ICONS_NAME.ROCKET_LAUNCH_SOLID,
    [AllianceStatusValues.ACTIVE]: ICONS_NAME.PLAY_CIRCLE_SOLID,
    [AllianceStatusValues.ABORTED]: ICONS_NAME.TIMES_CIRCLE_SOLID,
    [AllianceStatusValues.TERMINATED]: ICONS_NAME.STOP_CIRCLE_SOLID
};

export const AllianceStatusColorClass: Record<AllianceStatus, string> = {
    [AllianceStatusValues.DRAFT]: 'positive',
    [AllianceStatusValues.ACTIVE]: 'active',
    [AllianceStatusValues.ABORTED]: 'grey-darker',
    [AllianceStatusValues.TERMINATED]: 'negative'
};

export const AllianceStatusArray = Object.values(AllianceStatusValues);

export const AllianceListMode = {
    HUB: 'alliance.hub'
} as const;

export type IAllianceListMode = (typeof AllianceListMode)[keyof typeof AllianceListMode];

export const FILTERS = {
    ID: 'allianceId',
    NAME_SEARCH_TEXT: 'allianceSearchText',
    LEAD: `${ALLIANCE_PREFIX}leads`,
    TYPE: `${ALLIANCE_PREFIX}type`,
    STATUS: `${ALLIANCE_PREFIX}status`,
    OWNER: `${ALLIANCE_PREFIX}owner`,
    TERRITORIES: `${ALLIANCE_PREFIX}territories`,
    EFFECTIVE_DATE_BEGIN: `${ALLIANCE_PREFIX}effectiveDateBegin`,
    EFFECTIVE_DATE_END: `${ALLIANCE_PREFIX}effectiveDateEnd`,
    CREATED_BY: `${ALLIANCE_PREFIX}createdBy`,
    MODIFIED_BY: `${ALLIANCE_PREFIX}modifiedBy`,
    CREATED_ON_BEGIN: `${ALLIANCE_PREFIX}createdOnBegin`,
    CREATED_ON_END: `${ALLIANCE_PREFIX}createdOnEnd`,
    MODIFIED_ON_BEGIN: `${ALLIANCE_PREFIX}modifiedOnBegin`,
    MODIFIED_ON_END: `${ALLIANCE_PREFIX}modifiedOnEnd`,
    AUTHORIZED: `${ALLIANCE_PREFIX}authorizedOnly`,
    RELATED_COMPANIES: `${ALLIANCE_PREFIX}relatedCompanies`,
    COUNTRIES: `${ALLIANCE_PREFIX}countries`,
    COMPANY_TYPES: `${ALLIANCE_PREFIX}companyTypes`
} as const;

export const ALLIANCE_ID_REGEX = new RegExp(`${ALLIANCE_PREFIX}-\\d+`);
